import { render } from "./App.vue?vue&type=template&id=8d2d37d6"
const script = {}

import exportComponent from "/Users/huangmaobin/Desktop/test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__